import React from 'react';
import { useRecoilState, useRecoilValue } from 'recoil';

import {
  RenderTypeEnum,
  consoleState,
} from '@internal/console/atom';
import { viewTypeSelector, Size } from '@internal/window/selectors'
import InputPill, { PillOption } from "@components/input-pill";
import InputText from "@components/input-text";

import { selectionOutput } from './selection-texts';
import './index.scss'

type TerminalInputProps = {}

const TerminalInput = ({}: TerminalInputProps): JSX.Element => {
  const [{ rendering }, setConsoleState ] = useRecoilState(consoleState)
  const viewType = useRecoilValue(viewTypeSelector);

  function handleClick(opt: PillOption) {
    const validOptions = Object.keys(selectionOutput) as (keyof typeof selectionOutput)[];
    if (validOptions.includes(opt.value)) {
      const nextRenderings = selectionOutput[opt.value as (keyof typeof selectionOutput)];

      setConsoleState((prevState) => ({
        rendering: [...prevState.rendering.slice(1), ...nextRenderings],
        renderDelay: prevState.renderDelay,
        appendDelay: prevState.appendDelay,
        view: prevState.view,
        input: prevState.input,
      }))

      return
    }
  }

  const additionalClasses = viewType.size === Size.Small
  ? " input-small-view"
  : "";

  return (
    <div className={"terminal-input-container" + additionalClasses}>
      {rendering[0].type === RenderTypeEnum.InputOptions
        ? <InputPill
            options={rendering[0].options}
            handleClick={handleClick}
            />
        : <InputText />}

    </div>
  );
};

export default TerminalInput;
